import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-14789a6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-100 px-0 py-8",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CurrentEpochInfoBar = _resolveComponent("CurrentEpochInfoBar")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenuLayout = _resolveComponent("MenuLayout")!
  const _component_ResponsiveContainer = _resolveComponent("ResponsiveContainer")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "header-layout" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, { class: "header-layout__currency-details ant-row-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_CurrentEpochInfoBar)
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ResponsiveContainer, { class: "header-layout__header-navigation h-100" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_router_link, { to: `/` }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_MenuLayout, {
                menuItems: _ctx.menuItems,
                class: "header-layout__menu",
                theme: 'light',
                mode: 'horizontal'
              }, null, 8, ["menuItems"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}